// Where to go after signing in, when sign-in interrupted something.
//
// Only the AI agent approval page (/connect) asks for this today: an agent
// sends someone there, they may not be signed in, and after signing in they
// must land back on the approval, not the dashboard. Kept in sessionStorage,
// so it lives for this tab only, and always a path on this site, never a full
// address, so it can't be used to send someone elsewhere.
//
// Reading doesn't clear it: the login page and AuthProvider both navigate
// after sign-in, and whichever reads second must get the same answer. The
// approval page clears it once it has loaded, signed in, and it expires with
// the sign-in request (30 minutes) in case it never does.

const KEY = 'nhd_return_to';
const ALLOWED = ['/connect'];
const LIFETIME_MS = 30 * 60 * 1000;

const allowed = (path) => typeof path === 'string' && ALLOWED.some((p) => path === p || path.startsWith(`${p}?`));

export function rememberReturnTo(path) {
  if (!allowed(path)) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    // Private windows may refuse storage; signing in still works, it just lands on the dashboard
  }
}

// The remembered path, or `fallback`.
export function returnToPath(fallback = '/dashboard') {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && allowed(saved.path) && Date.now() - saved.at < LIFETIME_MS) return saved.path;
  } catch {
    // See above, or a value from before this format: ignore it
  }
  return fallback;
}

// Called by the page that was waiting, once it has opened.
export function clearReturnTo() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // See above
  }
}
